export const appHost = window._env_.REACT_APP_APP_PUBLIC_HOST || process.env.REACT_APP_APP_PUBLIC_HOST;
export const apiHost = window._env_.REACT_APP_API_HOST || process.env.REACT_APP_API_HOST;
export const authHost = window._env_.REACT_APP_AUTH_HOST || process.env.REACT_APP_AUTH_HOST;
console.log(process.env);